let requestedAt: number | undefined;

/**
 * Records that a navigation is under way, if one was not already. First call wins, so a redirect chain is
 * still dated from the request the reader actually made rather than from its last hop.
 */
export const markNavigationPending = () => {
  requestedAt ??= Date.now();
};

/**
 * Reads and clears when the navigation in progress was requested. Cleared on read so the next navigation
 * cannot inherit this one's timestamp; `undefined` means none was ever reported.
 */
export const takeNavigationRequestedAt = () => {
  const at = requestedAt;
  requestedAt = undefined;

  return at;
};
